/* eslint-disable jsx-a11y/anchor-is-valid */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function SidebarItem({label, onClick, aStyle, liStyle, icon}) {
  // Función que utiliza el componente original. Quiero que en el prop "icon" se pueda usar los mismos valores que en el componente original.
  const splitIcon = icon =>
    icon
      ? icon
          .match(/^([fab|fas|far]*)-?(.+)/)
          .splice(1, 2)
          .filter(p => p.length > 0)
      : null;

  const localIcon = splitIcon(icon);

  return (
    <li style={liStyle}>
      <a
        onClick={onClick}
        style={{width: '100%', cursor: 'pointer', ...aStyle}}>
        <FontAwesomeIcon
          color={null}
          icon={localIcon}
          style={{marginRight: '6px'}}
        />{' '}
        <span>{label}</span>
      </a>
    </li>
  );
}

export {SidebarItem};
